import React, { useState, useEffect } from 'react'
import SplashScreen from "../../components/loader/SplashScreen/SplashScreen";
import { SecurityServices, Settings, SoftwareResourceCluster, User, UserAdmin, UserAvatar } from '@carbon/icons-react';

import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Constants from '../../utils/Constants';
import Swal from 'sweetalert2';
import UsersList from './components/UsersList';
import RoleManagement from './components/RoleManagement';
import { ApiPost } from '../../utils/apiServices';



const Role = () => {





  const GetApi = (endpoint) => {
    return axios({
      method: "get",
      url: Constants.url + endpoint,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then((res) => {
      return res.data;
    });
  }

  const PutApi = (endpoint, data) => {
    return axios({
      method: "put",
      url: Constants.url + endpoint,
      data: data,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then((res) => {
      return res.data;
    });
  }





  const { data: USersdata, isLoading: USersisLoading } = useQuery({
    queryKey: ["USersdata"],
    queryFn: () => GetApi("admin/users"),
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 60,
  });

  const { data: RolesData, isLoading: RolesisLoading , refetch: refetchRoles } = useQuery({
    queryKey: ["RolesData"],
    queryFn: () => GetApi("roles"),
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 60,
  });



  const { data: permissionData, isLoading: PermissionisLoading , refetch: refetchPermission } = useQuery({
    queryKey: ["Permissiondata"],
    queryFn: () => GetApi("permissions"),
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 60,
  });




  const [isLoading, setisloading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);


  


  const [roleName, setRoleName] = useState('')
  // SIMPLIFIED PERMISSION STATE: flat object { 'moduleId-permKey': bool }
  const [selectedPermissions, setSelectedPermissions] = useState({});

  useEffect(() => {
    if (!permissionData) return;
    const initial = {};
    permissionData.forEach(module => {
      module.permissions.forEach(perm => {
        initial[`${module.moduleId}-${perm.key}`] = false;
      });
    });
    setSelectedPermissions(initial);
  }, [permissionData]);

  const togglePermission = (moduleId, permKey) => {
    const key = `${moduleId}-${permKey}`;
    setSelectedPermissions(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const toggleAllPermissions = (select) => {
    if (!permissionData) return;
    const updated = {};
    permissionData.forEach(module => {
      module.permissions.forEach(perm => {
        updated[`${module.moduleId}-${perm.key}`] = select;
      });
    });
    setSelectedPermissions(updated);
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault()
    setSubmitLoading(true)

    const formData = {
      name: roleName,
      modules: []
    }

    if (permissionData) {
      permissionData.forEach(module => {
        const moduleData = {
          name : module.name,
          moduleId: module._id,
          permissions: []
        }
        module.permissions.forEach(perm => {
          const key = `${module.moduleId}-${perm.key}`;
          moduleData.permissions.push({
            key: perm.key,
            enabled: selectedPermissions[key] || false
          });
        });
        formData.modules.push(moduleData);
      });
    }

    

    

      ApiPost('roles' , formData)

      .then((resp ) => {
          refetchRoles()

          setSubmitLoading(false)
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: resp.message,
            confirmButtonColor: 'black',
          })
      })
      .catch((err) => {
        setSubmitLoading(false)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err.response.data.message,
        })
      })
      .finally(() => {
        setSubmitLoading(false)
      })
  }



  const HandleRoleChange = (userId) => {

    Swal.fire({
      title: 'Are you sure? ' + userId,
      text: 'You want to change the role of this user?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    })
      .then((result) => {
        if (result.isConfirmed) {
          PutApi("roles/" + userId, { role: roleName })
            .then((res) => {
              if (res.data.status === "success") {
                Swal.fire({
                  icon: "success",
                  title: "Role Changed",
                })
              }
            })
        }
      })
  }


  // const modules = 

  return (
    <>
      {!isLoading ? (
        <div className="dashboardWrp">
          <div className="uk-container uk-container-expand">
            <div className="dashboardTop">
              <div uk-grid="" className="uk-grid">
                <div className="uk-width-1-1">
                  <div className="uk-margin ">
                    <div className="uk-flex uk-flex-between ">
                      <div>
                        <h2>Permissions  Management</h2>
                      </div>
                    </div>
                  </div>

                  <div className="RolesnewTabs ">
                    <ul
                      className="uk-subnav uk-subnav-pill  RolesTabs "
                      uk-switcher="connect: #analyticsTabs"
                      uk-tab='animation: uk-animation-fade'
                      
                    >

                      <li>
                        <a> <span> <UserAvatar size={24} /> Users </span> </a>
                      </li>
                      <li>
                        <a> <span> <SoftwareResourceCluster size={24} /> Roles </span> </a>
                      </li>
                      {/* <li>
                     <a> <span> <Settings size={24} /> Create Users </span> </a>
                   </li> */}
                      <li>
                        <a> <span> <Settings size={24} /> Create Roles </span> </a>
                      </li>

                    </ul>

                    <div className="tabContent"  >
                      <ul className="uk-switcher uk-margin" id="analyticsTabs"  >
                        <li>
                          <UsersList USersdata={USersdata} role={RolesData} />

                        </li>



                        <li>
                          <RoleManagement RolesData={RolesData} refetch={refetchRoles} />

                        </li>



                        <li>
                          <div className='uk-card uk-card-default uk-card-body'>
                            <div className="uk-padding">
                              <h2>Create New Role
                              </h2>
                              <p className='uk-margin-bottom'>Create new roles and assign permissions to them

                              </p>
                              <form className='' onSubmit={handleSubmit}>
                                <div className="uk-margin formInput ">
                                  <label className="uk-form-label" htmlFor="RoleName"><h4>Role Name</h4></label>
                                  <input
                                    className="uk-input"
                                    id="RoleName"
                                    name="RoleName"
                                    type="text"
                                    placeholder="Name"
                                    value={roleName}
                                    onChange={(e) => setRoleName(e.target.value)}
                                    required
                                  />
                                </div>


                                <div className="uk-flex uk-flex-between ">

                                <h3 className="uk-margin-top">Permissions by Module</h3>

                                <div className="uk-align-right uk-margin-bottom" style={{alignItems:'baseline'}}>
                                  <button
                                    type="button"
                                    className="uk-button uk-button-secondary uk-margin-small-right"
                                    onClick={() => toggleAllPermissions(true)}
                                  >
                                    Select All
                                  </button>
                                  <button
                                    type="button"
                                    className="uk-button uk-button-default"
                                    onClick={() => toggleAllPermissions(false)}
                                  >
                                    Deselect All
                                  </button>
                                </div>

                                </div>

                                {permissionData ? [...permissionData].reverse().map((module) => (
                                  <div key={module.moduleId} className="uk-margin-medium-bottom">
                                    <div className='uk-card uk-card-default uk-card-body'>
                                      <div className="uk-form-label uk-text-bold uk-text-large uk-margin-bottom">{module.name}</div>
                                      <div className="uk-grid-small uk-child-width-1-2 uk-child-width-1-3@m uk-margin-left" uk-grid="">
                                        {module.permissions.map((permission) => (
                                          <div key={`${module.moduleId}-${permission.key}`}>
                                            <div className="uk-flex uk-flex-middle">
                                              <input
                                                className="uk-checkbox uk-margin-small-right"
                                                type="checkbox"
                                                style={{color:'red'}}
                                                id={`${module.moduleId}-${permission.key}`}
                                                checked={selectedPermissions[`${module.moduleId}-${permission.key}`] || false}
                                                onChange={() => togglePermission(module.moduleId, permission.key)}
                                              />
                                              <div>
                                                <label
                                                  htmlFor={`${module.moduleId}-${permission.key}`}
                                                  className="uk-form-label uk-text-capitalize uk-text-bold "
                                                  style={{fontSize:'18px'}} 
                                                >
                                                  {permission.label}
                                                </label>
                                                <p className="uk-text-meta uk-margin-remove-top">{permission.description}</p>
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                )) : null}

                                <button
                                  className="uk-button uk-align-right uk-button-secondary"
                                  type="submit"
                                  disabled={!roleName.trim()}
                                >
                                  {submitLoading ? 'Creating...' : 'Create Role'}
                                </button>
                              </form>
                            </div>
                          </div>
                        </li>





                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <SplashScreen />
      )}
    </>
  )
}

export default Role